import { useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { USERS_COLLECTION } from "../../constants";
import db from "../../firebaseConfig";
import { updateUsers, updateUsersCollections } from "../../redux/users/usersActions";
import LoadingIndicator from "../layouts/LoadingIndicator";

const UserPage = ({ usersList, updateUsersCollections, updateUsers }) => {

    const {users, lastDocId, hasMore, loading } = usersList;

    const history = useHistory();
    
    useEffect(() => {
        if(users.length === 0) {
            return getData();
        }
    }, []);

    const getData = async () => await db.collection(USERS_COLLECTION)
    .where('createdAt', '>=', Date(Date.now().year, Date.now().month, Date.now().day-7))
            .orderBy('createdAt','desc').limit(15).get()
            .then((collections) => updateUsersCollections(collections));

    const fetchTopupsData = async () => {
        if(lastDocId) {
            return await db.collection(USERS_COLLECTION)
            .where('createdAt', '>=', Date(Date.now().year, Date.now().month, Date.now().day-7))
            .orderBy('createdAt','desc')
            .startAfter(lastDocId)
            .limit(15)
            .get()
            .then((collections) => {
                updateUsersCollections(collections);
            });
        }
    }

    return (
        <div className="min-h-screen">
            <div className="flex w-full justify-between bg-blue-400 py-4 px-4 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow">
                <button onClick={() => history.goBack()} className=" text-gray-200">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
                    </svg>
                </button>
                <p className="m-auto inset-0 text-xl font-semibold leading-7 text-center text-gray-200">All Users List</p>
            </div>
            <div className="">
                <InfiniteScroll
                    dataLength={users.length} //This is important field to render the next data
                    next={fetchTopupsData}
                    hasMore={hasMore}
                    style={{height: 'unset', overflow: 'unset'}}
                    loader={<LoadingIndicator/>}
                    endMessage={
                        <p className="text-gray-500 mt-2" style={{ textAlign: 'center' }}>
                        <b>Yay! You have seen it all</b>
                        </p>
                    }
                    >
                    <div className="flex justify-center items-center mt-10">
                        <div className="space-y-4 w-full md:w-1/2 lg:w-1/2 px-4">
                            {
                                users.map((profile, index) => {
                                        return (
                                            <div key={index} className="bg-blue-400 border-gray-500 border-opacity-60 | p-4 border-solid rounded-3xl border-2 | flex w-full items-center justify-start cursor-pointer hover:border-transparent | transition-colors duration-500 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow">
                                            <img className="w-12 h-12 object-cover rounded-full" src={profile.photoURL} alt="profile" />
                                            <div className="flex flex-col w-full justify-center pl-4">
                                                <p className="text-gray-200 dark:text-gray-300 font-semibold">{profile.displayName}</p>
                                                <p className="text-gray-400 dark:text-gray-100 text-justify font-semibold">{new Date(profile.createdAt.toDate()).toDateString()}</p>
                                            </div>
                                            <Link className="w-12" to={{pathname: "/chat-room",state: {user: profile}}}><span className="material-icons-outlined text-red-400">chat</span></Link>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </InfiniteScroll>
            </div>
        </div>
    );
}



const mapStateToProps = state => {
    return {
        usersList: state.users
    };
}


const mapDispatchToProps = dispatch => {
    return {
        updateUsers: (users) => dispatch(updateUsers(users)),
        updateUsersCollections: (users) => dispatch(updateUsersCollections(users)),
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(UserPage);